import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class CurrencyConfigService {
  private defaultLocale = 'en-US'
  private defaultCurrency = 'USD'
  // private defaultLocale = 'de-DE'
  // private defaultCurrency = 'EUR'

  setLocale(locale: string) {
    this.defaultLocale = locale
  }

  setCurrency(currency: string) {
    this.defaultCurrency = currency
  }

  getLocale(): string {
    return this.defaultLocale
  }

  getCurrency(): string {
    return this.defaultCurrency
  }
}
